function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1, 1)",
  fill: "#d2d2d2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M216.9-1H95.5v22.1H33.8L-1,83.4v59h20.9c3.4,16.1,17.8,28.2,34.9,28.2 s31.4-12.1,34.9-28.2h31.7c3.4,16.1,17.8,28.2,34.9,28.2s31.4-12.1,34.9-28.2H217L216.9-1L216.9-1z M75.5,134.9 c0,11.4-9.3,20.7-20.7,20.7S34,146.4,34,134.9c0-11.4,9.3-20.7,20.7-20.7S75.5,123.5,75.5,134.9z M95.5,127.5h-5.9 c-3.4-16.1-17.8-28.2-34.9-28.2s-31.4,12.1-34.9,28.2h-5.9V87.3l28.6-51.2h53C95.5,36.1,95.5,127.5,95.5,127.5z M176.9,134.9 c0,11.4-9.3,20.7-20.7,20.7s-20.7-9.3-20.7-20.7s9.3-20.7,20.7-20.7C167.6,114.2,176.9,123.5,176.9,134.9z M201.9,127.5h-10.8 c-3.4-16.1-17.8-28.2-34.9-28.2s-31.4,12.1-34.9,28.2h-10.8V14H202L201.9,127.5L201.9,127.5z"
}));

function SvgEpLoad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 218 171.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpLoad);
export default __webpack_public_path__ + "static/media/ep-load.ba2d25c4.svg";
export { ForwardRef as ReactComponent };